import { REVIEW_STATUS, INVITE_STATUS, CLAIM_STATUS } from "@/lib/api";

const tone = {
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  approved: "bg-emerald-50 text-emerald-800 border-emerald-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  scheduled: "bg-gray-50 text-gray-700 border-gray-200",
  sent: "bg-sky-50 text-sky-800 border-sky-200",
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  failed: "bg-red-50 text-red-700 border-red-200",
  aperta: "bg-amber-50 text-amber-800 border-amber-200",
  in_gestione: "bg-sky-50 text-sky-800 border-sky-200",
  risolta: "bg-emerald-50 text-emerald-800 border-emerald-200",
  respinta: "bg-red-50 text-red-700 border-red-200",
};

const Pill = ({ status, label }) => (
  <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${tone[status] || tone.scheduled}`} data-testid={`status-${status}`}>
    {label}
  </span>
);

export const ReviewStatusBadge = ({ status }) => <Pill status={status} label={REVIEW_STATUS[status]} />;
export const InviteStatusBadge = ({ status }) => <Pill status={status} label={INVITE_STATUS[status]} />;
export const ClaimStatusBadge = ({ status }) => <Pill status={status} label={CLAIM_STATUS[status]} />;
